import { createApi } from '@reduxjs/toolkit/query/react'
import { customFetchBaseQuery } from '../app/baseQuery'

import type {
  FindAvailableTreatmentIdsPerClinicRequest,
  FindAvailableTreatmentIdsPerClinicResponse,
} from '../../types/patient-api-gateway/api/patient/v1/patient_gateway_service'
import { DateTime as GoogleDateTime } from '../../types/patient-api-gateway/google/type/datetime'

export type FindAvailableTreatmentIdsPerClinicQueryArgs = {
  clinicIds: string[]
  startTime: GoogleDateTime
  endTime: GoogleDateTime
}

export const treatmentApi = createApi({
  reducerPath: 'treatmentApi',
  baseQuery: customFetchBaseQuery,
  tagTypes: ['Treatment'],
  endpoints: (builder) => ({
    findAvailableTreatmentIdsPerClinic: builder.query<
      FindAvailableTreatmentIdsPerClinicResponse,
      FindAvailableTreatmentIdsPerClinicQueryArgs
    >({
      query: ({ clinicIds, startTime, endTime }) => ({
        url: '/api.patient.v1.PatientGatewayService/FindAvailableTreatmentIdsPerClinic',
        method: 'POST',
        body: {
          clinicIds,
          startTime,
          endTime,
        } as FindAvailableTreatmentIdsPerClinicRequest,
      }),
      extraOptions: {
        maxRetries: 3,
      },
      providesTags: ['Treatment'],
      keepUnusedDataFor: 60,
    }),
  }),
})

export const { useFindAvailableTreatmentIdsPerClinicQuery } = treatmentApi
